// extracted by mini-css-extract-plugin
module.exports = {"brand":"Navbar_brand__2dAVp","toolbox":"Navbar_toolbox__1JPRq","speed":"Navbar_speed__2Af1Z"};